<template>
    <div class="barbour-abi-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Project Leads in partnership with Barbour ABI
                </div>
                <div class="logo">
                    <img src="/images/barbour-abi-logo.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Construction Project Leads</h1>
                <p>
                    As an Approved Epwin Window Systems Commercial Partner, you have free access to Barbour ABI — the market‑leading provider of construction intelligence and building project leads, tailored to your regional area.
                </p>
                <p>
                    Barbour ABI helps you identify upcoming opportunities, track live projects, and plan your pipeline with confidence.
                </p>
                <a href="https://app.barbour-abi.com/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                    <strong>Login to Barbour ABI</strong>
                </a>
            </div>
            <div class="box-2">
                <h1>New to Barbour ABI? We’ve Got You Covered</h1>
                <p>
                    Not sure where to start or how to get the most out of Barbour ABI? No problem. We’ve pulled together a range of support options to help you:
                </p>
                <ul>
                    <li>
                        Understand the platform and its features
                    </li>
                    <li>
                        Set up your account for success
                    </li>
                    <li>
                        Get tailored guidance based on your business needs
                    </li>
                </ul>
                <a href="https://barbour-abi.com/resources/training-room/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                    <strong>Visit the Barbour ABI Training Room</strong>
                </a>
                <p>
                    Access the Barbour ABI Training Room, featuring short, practical videos from Barbour ABI’s expert trainers and industry professionals.
                    Ideal for getting up and running quickly and learning how to make the platform work for your commercial growth.
                </p>
                <a class="btn-primary _lg" @click.prevent="openTrainingEnquiryBox()">
                    Request Bespoke ABI Training
                </a>
            </div>
            <div class="overlapping-image">
                <img src="/images/commercial-construction-project-leads-header.png">
            </div>
            <div class="box-3">
                <h1>What is Barbour ABI?</h1>
                <p>
                    The in-house Barbour ABI team tracks every planning application and thousands of non-
                    planning projects across the UK to deliver valuable insight, up-to-date construction leads
                    and industry data.
                </p>
                <p>
                    Its extensive construction database is regularly updated with relevant decision-maker
                    contact details, project stage and location, build values and the type of materials being
                    specified on site to deliver the most up-to-date and relevant construction project
                    opportunities from pre-planning through to sub-contracting.
                </p>
                <div>
                    <a class="btn-primary _lg" @click.prevent="openAccountEnquiryBox()">
                        Request a Barbour Account
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Barbour ABI Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        {{ enquiry_box_copy }}
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            enquiry_box_copy: 'Please enter details of your enquiry below.',
            enquiry_box_open: false,
            enquiry_message: 'I would like some more information on signing up for a free Barbour ABI login',
            sending: false,
        }
    },
    methods: {
        openAccountEnquiryBox() {
            this.enquiry_box_copy = 'Please enter details of your enquiry below.';
            this.enquiry_message = 'I would like some more information on signing up for a free Barbour ABI login';
            this.enquiry_box_open = true;
        },
        openTrainingEnquiryBox() {
            this.enquiry_box_copy = 'Submit this form to request bespoke ABI training. A member of the team will review your enquiry and contact you to discuss requirements and next steps.';
            this.enquiry_message = 'I would like to request bespoke ABI training';
            this.enquiry_box_open = true;
        },
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 13,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Barbour ABI enquiry',
                'value': 'Barbour ABI enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
        partnerLinkClicked() {
          axios.post('/activity-logs/createActivityLogFromRequest', {
            'activity_log_category_id': 3,
            'description': `Partner Link Clicked - Barbour ABI`,
          });
          gtag('event', 'partner_link_clicked', {
            'event_category': 'link',
            'event_label': 'Barbour ABI partner link clicked',
            'value': 'Barbour ABI partner link clicked',
          });
        },
    },
};
</script>
